<template>
    <transition name="slide-fade">
        <div class="modal" :class="{'open' : open}" v-if="open">
            <div class="modal-content">
                <div class="bg-white w-full rounded-xl p-3">
                    <FormDeliveryAddress ref="form-delivery-address"></FormDeliveryAddress>
                    <div class="text-right px-2">
                        <button class="bg-gray-300 text-white rounded-md py-1 px-4 mr-2"
                                @click="clickCancel()">
                            Cancel
                        </button>
                        <button class="bg-blue-600 text-white rounded-md py-1 px-4"
                                @click="clickOk()">
                            Save
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </transition>

    <transition name="fade">
        <div class="modal-backdrop" v-if="open"></div>
    </transition>
</template>
<script>
// import Util from "@/helper/Utility.js";
import LocaleMixin from "@/mixin/LocaleMixin.js";
//component
import FormDeliveryAddress from "@/module/Address/DeliveryAddress/component/FormDeliveryAddress.vue";
//service
import BzbsAddressList from "@/core/Address/service/BzbsAddressList.js";

export default {
    name: "AddAddressModal",
    mixins: [LocaleMixin],
    components: {
        FormDeliveryAddress
    },
    props: {
        controller: Object,
    },
    data: function() {
        return {
            open: false,
            busModal: null,
        };
    },
    created: function() {
        this.busModal = this.controller.busModal;
    },
    mounted: function() {
        this.busModal.on('show', this.show);
        this.busModal.on('hide', this.hide);
    },
    methods: {
        show: function() {
            document.body.classList.add('not-scroll');
            this.open = true;

            this.$nextTick(() => {
                this.$refs['form-delivery-address'].clearForm();
            });
        },
        hide: function() {
            document.body.classList.remove('not-scroll');
            this.open = false;
        },
        clickCancel: function() {
            this.hide();
            this.controller.sendCallbackCancel();
        },
        clickOk: function () {
            this.saveAddress();
        },

        saveAddress: function() {
            let formData = this.$refs['form-delivery-address'].submitForm();
            if (formData != null) {
                let params = formData.getParams();
                this.saveAddressApi(params);
            }
        },
        saveAddressApi: function(params) {
            this.hide();
            this.controller.loadingModal.show();

            BzbsAddressList.apiAddAddress(params).subscribe(() => {
                this.controller.loadingModal.hide();
                this.controller.sendCallbackAddSuccess();
                // console.log(data);
            }, (err) => {
                this.controller.loadingModal.hide();
                console.log(err);

                let msg = err.message;
                this.controller.alertModal.clearModal()
                        .setMsg(msg)
                        .show();
                this.controller.alertModal.onClickOk(() => {
                    this.show();
                });
            });
        },
    },
}
</script>
<style lang="scss" scoped>
    @import "@/style/base/base.scss";
    @import "@/style/modal.scss";

    .modal {
        @extend %modal;

        .modal-content {
            width: 420px;

            @include mobile {
                width: 100%;
                padding: 16px;
            }
        }
    }
</style>
